//# sourceMappingURL=options.mjs.map
/// <reference types="./options.d.mts" />
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import { CustomType as $CustomType } from "../../gleam.mjs";

class Options extends $CustomType {
  constructor(domain, client_id, use_refresh_token, use_refresh_token_fallback, authorization_params) {
    super();
    this.domain = domain;
    this.client_id = client_id;
    this.use_refresh_token = use_refresh_token;
    this.use_refresh_token_fallback = use_refresh_token_fallback;
    this.authorization_params = authorization_params;
  }
}

class AuthorizationParams extends $CustomType {
  constructor(audience, scope, connection, organization, invitation, redirect_uri, custom_parameters) {
    super();
    this.audience = audience;
    this.scope = scope;
    this.connection = connection;
    this.organization = organization;
    this.invitation = invitation;
    this.redirect_uri = redirect_uri;
    this.custom_parameters = custom_parameters;
  }
}

export function new$(domain, client_id) {
  return new Options(domain, client_id, false, true, new None());
}

export function use_refresh_token(options, use_refresh_token) {
  return new Options(
    options.domain,
    options.client_id,
    use_refresh_token,
    options.use_refresh_token_fallback,
    options.authorization_params,
  );
}

export function use_refresh_token_fallback(options, use_refresh_token_fallback) {
  return new Options(
    options.domain,
    options.client_id,
    options.use_refresh_token,
    use_refresh_token_fallback,
    options.authorization_params,
  );
}

export function with_authorization_params(options, authorization_params) {
  return new Options(
    options.domain,
    options.client_id,
    options.use_refresh_token,
    options.use_refresh_token_fallback,
    new Some(authorization_params),
  );
}

export function authorization_params() {
  return new AuthorizationParams(
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
  );
}

export function audience(params, audience) {
  return new AuthorizationParams(
    new Some(audience),
    params.scope,
    params.connection,
    params.organization,
    params.invitation,
    params.redirect_uri,
    params.custom_parameters,
  );
}

export function scope(params, scope) {
  return new AuthorizationParams(
    params.audience,
    new Some(scope),
    params.connection,
    params.organization,
    params.invitation,
    params.redirect_uri,
    params.custom_parameters,
  );
}

export function connection(params, connection) {
  return new AuthorizationParams(
    params.audience,
    params.scope,
    new Some(connection),
    params.organization,
    params.invitation,
    params.redirect_uri,
    params.custom_parameters,
  );
}

export function organization(params, organization) {
  return new AuthorizationParams(
    params.audience,
    params.scope,
    params.connection,
    new Some(organization),
    params.invitation,
    params.redirect_uri,
    params.custom_parameters,
  );
}

export function invitation(params, invitation) {
  return new AuthorizationParams(
    params.audience,
    params.scope,
    params.connection,
    params.organization,
    new Some(invitation),
    params.redirect_uri,
    params.custom_parameters,
  );
}

export function redirect_uri(params, redirect_uri) {
  return new AuthorizationParams(
    params.audience,
    params.scope,
    params.connection,
    params.organization,
    params.invitation,
    new Some(redirect_uri),
    params.custom_parameters,
  );
}

export function custom_parameter(params, parameter, value) {
  let _pipe = params.custom_parameters;
  let _pipe$1 = $option.unwrap(_pipe, $dict.new$());
  let _pipe$2 = $dict.insert(_pipe$1, parameter, value);
  return ((d) => {
    return new AuthorizationParams(
      params.audience,
      params.scope,
      params.connection,
      params.organization,
      params.invitation,
      params.redirect_uri,
      new Some(d),
    );
  })(_pipe$2);
}

export function connection_scope(params, scope) {
  return custom_parameter(params, "connection_scope", scope);
}
